import React from "react";
import Header from "../layout/Header";
import "./index.scss";
const MentionsLegales = () => {
  return (
    <>
      <div className="slide-mention">
        <Header />
        <div className="slide-mention-container ">
          <div className="row  align-items-center  h-100 mb-5">
            {" "}
            <h1 className="title-mentions ">Mentions légales</h1>
          </div>
        </div>
      </div>
      <div className="container">
        <p>
          Éditeur : L’éditeur de ce site Internet est la Fondation Junior MBUYI,
          une organisation humanitaire dédiée à l’amélioration des conditions de
          vie en milieu rural.
          <br />
          Email : info@jpgconsulting-partners.com <br /> Tél. : (+41) 51 23 00
          00
          <br /> Éditeur responsable : Mr Junior M'BUYI
          <br /> Protection de la vie privée <br /> La Fondation Junior MBUYI
          s'engage à respecter la vie privée des visiteurs de son site Internet.
          <br />
          Lors de la visite du site https://www.juniormbuyifoundation.com/, des
          « cookies » peuvent être installés sur le terminal des utilisateurs.
          Ces cookies sont utilisés pour optimiser l'expérience de navigation et
          assurer le bon fonctionnement technique du site.
          <br /> Ces cookies ne permettent pas d’identifier les visiteurs
          individuellement.
          <br /> Les visiteurs peuvent configurer leur navigateur pour refuser
          ou supprimer les cookies. Cependant, cela pourrait affecter la
          fluidité de la navigation sur le site.
          <br /> Droits intellectuels : <br /> La Fondation Junior MBUYI
          conserve tous ses droits de propriété intellectuelle, y compris sur
          les textes, images, photographies, et la mise en page de ce site.
          <br /> Toute reproduction, modification, traduction ou diffusion,
          totale ou partielle, du contenu ou de la mise en page du site
          https://www.juniormbuyifoundation.com/ est strictement interdite sans
          autorisation préalable écrite de la Fondation Junior MBUYI.
          <br /> Les utilisateurs s’engagent à ne pas enfreindre les lois sur le
          droit d’auteur en vigueur.
          <br /> Disclaimer
          <br /> Les informations publiées sur le site
          https://www.juniormbuyifoundation.com/ ont un caractère général et
          uniquement informatif. Elles ne constituent en aucun cas un engagement
          contractuel ou précontractuel de la Fondation Junior MBUYI.
          <br /> La Fondation Junior MBUYI met tout en œuvre pour fournir des
          informations exactes et à jour sur son site. Toutefois, elle ne
          garantit pas l'exhaustivité ou l'actualité des contenus et décline
          toute responsabilité en cas d'erreurs ou d’omissions. <br /> Dans les
          limites autorisées par la loi, la Fondation Junior MBUYI exclut toute
          responsabilité pour des dommages résultant de l'utilisation ou de
          l'impossibilité d'utiliser ce site, notamment en cas d'interruptions
          de service ou de pertes de données.
          <br /> La Fondation Junior MBUYI n’est pas responsable des contenus
          des sites tiers vers lesquels ce site peut renvoyer ni des sites tiers
          qui renvoient vers ce site.
          <br /> Tout lien vers le site https://www.juniormbuyifoundation.com/
          doit faire l'objet d'une autorisation préalable écrite de la Fondation
          Junior MBUYI.
          <br /> Droit applicable et juridictions compétentes
          <br /> Le contenu du site https://www.juniormbuyifoundation.com/ est
          régi par le droit Français. Tout litige relatif à ce site relève de la
          compétence exclusive des tribunaux de [Paris/France].
          <br />
          Hébergement
          <br /> Hébergeur : <a href="https://msit-conseil.fr">MSIT-CONSEIL</a>
          <br /> Tél. : +33 1 85 47 15 41 <br /> Email : contact@msit-conseil.fr
        </p>
      </div>
    </>
  );
};

export default MentionsLegales;
